import { AspectRatio } from "@/shared-web.ui/ui.aspect-ratio";
import { Box } from "@/shared-web.ui/ui.box";
import { Grid } from "@/shared-web.ui/ui.grid";
import { Skeleton } from "@/shared-web.ui/ui.skeleton";
import {
  type ProductListingSummary,
} from "@/stf.data/schema";

import { PrimProductCard } from "../prim.product-card";
import { PrimProductSmallDetail } from "../prim.product-small-detail";

type CardGenericProps = {
  className?: string;
} & ProductListingSummary;

const CardVertical = (props: CardGenericProps) => {
  const {
    title,
    badgeList,
    brandDetail,
    imageList,
    productAttribute,
    ratingDetail,
    unitSold,
    productSlug,
    shopDetail: {
      shopSlug,
    },
    stockStatus,
    className,
    variantSku,
  } = props;

  return (
    <PrimProductCard.Card
      direction="column"
      slugProduct={productSlug}
      slugShop={shopSlug}
      className={className}
    >
      <PrimProductCard.ImageVertical
        alt={title}
        src={imageList[0]}
        stockStatus={stockStatus}
      />
      <PrimProductCard.Body>
        {badgeList && badgeList.length > 0
        && (
          <PrimProductCard.BadgeSection>
            {badgeList.map((badgeLabel) => {
              return (
                <PrimProductCard.Badge key={badgeLabel}>{badgeLabel}</PrimProductCard.Badge>
              );
            })}
          </PrimProductCard.BadgeSection>
        )}
        {
          brandDetail.brandName !== "No Brand"
          && <PrimProductCard.BrandDetail {...brandDetail} />
        }
        <PrimProductCard.ProductName
          name={title}
        />
        <PrimProductCard.GenericAttribute
          attrList={
            productAttribute
          }
        />
        <PrimProductCard.Footer>
          <PrimProductCard.PriceContainer>
            <PrimProductSmallDetail.PricePercent
              finalPrice={variantSku.promoPrice}
              stickerPrice={variantSku.retailPrice}
              discountPercentage={variantSku.discountPercentage}
              weight="bold"
            />
          </PrimProductCard.PriceContainer>
          <PrimProductCard.Satisfaction
            ratingDetail={ratingDetail}
            unitSold={unitSold}
          />
        </PrimProductCard.Footer>
      </PrimProductCard.Body>
    </PrimProductCard.Card>
  );
};

const CardHorizontal = (props: CardGenericProps) => {
  const {
    title,
    badgeList,
    brandDetail,
    imageList,
    productAttribute,
    ratingDetail,
    unitSold,
    productSlug,
    shopDetail: {
      shopSlug,
    },
    stockStatus,
    variantSku,
    className,
  } = props;

  return (
    <PrimProductCard.Card
      className={className}
      direction="row"
      slugProduct={productSlug}
      slugShop={shopSlug}
    >
      <Grid
        className="w-full"
        columns="200px 1fr"
      >
        <PrimProductCard.ImageHorizontal
          alt={title}
          src={imageList[0]}
          stockStatus={stockStatus}
        />
        <PrimProductCard.Body>
          {badgeList && badgeList.length > 0
          && (
            <PrimProductCard.BadgeSection>
              {badgeList.map((badgeLabel) => {
                return (
                  <PrimProductCard.Badge key={badgeLabel}>{badgeLabel}</PrimProductCard.Badge>
                );
              })}
            </PrimProductCard.BadgeSection>
          )}
          {
            brandDetail.brandName !== "No Brand"
            && <PrimProductCard.BrandDetail {...brandDetail} />
          }
          <PrimProductCard.ProductName
            name={title}
          />
          <PrimProductCard.GenericAttribute
            attrList={
              productAttribute
            }
          />
          <PrimProductCard.Footer>
            <PrimProductCard.PriceContainer>
              <PrimProductSmallDetail.PricePercent
                finalPrice={variantSku.promoPrice}
                stickerPrice={variantSku.retailPrice}
                discountPercentage={variantSku.discountPercentage}
                weight="bold"
              />
            </PrimProductCard.PriceContainer>
            <PrimProductCard.Satisfaction
              ratingDetail={ratingDetail}
              unitSold={unitSold}
            />
          </PrimProductCard.Footer>
        </PrimProductCard.Body>
      </Grid>
    </PrimProductCard.Card>
  );
};

const CardGeneric = (props: CardGenericProps) => {
  return (
    <>
      <Box
        display={{
          initial: "none",
          md: "block",
        }}
      >
        <CardHorizontal {...props} />
      </Box>
      <Box
        display={{
          initial: "block",
          md: "none",
        }}
      >
        <CardVertical {...props} />
      </Box>
    </>
  );
};

const CardSkeleton = () => {
  return (
    <>
      <Skeleton>
        <Box
          className="rounded-3"
          display={{
            initial: "none",
            md: "block",
          }}
        >
          <AspectRatio ratio={500 / 250}>
            {" "}
          </AspectRatio>
        </Box>
      </Skeleton>
      <Skeleton>
        <Box
          className="rounded-3"
          display={{
            initial: "block",
            md: "none",
          }}
        >
          <AspectRatio ratio={1}>
            {" "}
          </AspectRatio>
          <Box height="150px" />
        </Box>
      </Skeleton>
    </>
  );
};

export {
  CardGeneric,
  CardHorizontal as CardGenericHorizontal,
  CardSkeleton,
  CardVertical as CardGenericVertical,
};
